module.exports = __webpack_public_path__ + "static/media/om_nose_widebase.c4b09e42.png";